import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsKayakingNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M17 30.02v1.75c0 2.566.629 5.093 1.83 7.36L23.06 47h1.88l4.23-7.88A15.693 15.693 0 0031 31.77v-9.19l-2 1.06v8.13c0 2.234-.547 4.434-1.59 6.41L24 44.53l-3.41-6.34A13.8 13.8 0 0119 31.77v-2.81l-2 1.06z"
        fill=""
      />
      <path
        d="M21 27.9v.1a3 3 0 006 0v-3.29l-2 1.06V28a1 1 0 01-2 0v-1.17l-2 1.07z"
        fill=""
      />
      <path
        d="M9.42 34.11l2.45-3.62v-.01L17 27.76v-.01l6-3.18v-.01l8-4.24v-.01L37.22 17h3.73a4.98 4.98 0 002.27-.56L48 13.91V5.98l-9.56 5.06A4.6 4.6 0 0036 15.1v.29l-5 2.66v-2.24a15.751 15.751 0 00-1.86-7.41L25.13 1l-.01-.01h-2.26l-.01.01-4 7.41A15.75 15.75 0 0017 15.8v9.69l-6.44 3.42a4.601 4.601 0 00-4.67-.21L0 31.83v7.93l7.68-4.08c.701-.37 1.3-.91 1.74-1.57zm29.96-21.3L46 9.3v3.4l-3.72 1.97c-.41.218-.866.331-1.33.33H38a2.6 2.6 0 011.38-2.19zM25 21.24l-2 1.06V20a1 1 0 012 0v1.24zm-6-5.44a13.752 13.752 0 011.61-6.44l3.38-6.26 3.39 6.25A13.722 13.722 0 0129 15.81v3.3l-2 1.07V20a3 3 0 00-6 0v3.37l-2 1.06V15.8zM6.75 33.91L2 36.43v-3.4l4.82-2.56a2.578 2.578 0 012.59.08L7.76 33a2.93 2.93 0 01-1.01.91z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKayakingNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsKayakingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsKayakingNormalLarge;
